import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button, Dialog, DialogActions, DialogContent } from "@material-ui/core";
import MyDocument, { getInvoiceNumber } from "./MyDocument.js";
import { Document, PDFViewer } from "@react-pdf/renderer";
import API from "../../actions";
import { useHistory } from "react-router-dom";
import update from "immutability-helper";
import Loading from "../Common/loading";

export default props => {
    const history = useHistory();
    const therapist = useSelector(state => state.data.therapist);
    const [open, setOpen] = useState(false);
    const [openLoading, setOpenLoading] = useState(false);
    const [company, setCompany] = useState({});
    const [client, setClient] = useState({});
    const [treatment, setTreatment] = useState({});
    const [stamJournal, setStamJournal] = useState("");
    const [journal, setJournal] = useState("");
    const [upComing, setUpComing] = useState("");
    const [cvr, setCvr] = useState({});
    const [invoiceNumber, setInvoiceNumber] = useState(0);
    const curYear = new Date().getFullYear().toString().substr(-2);

    const { dineroErrorMessages, setDineroErrorMessages } = props;

    const handleClickOpen = async () => {
        setOpenLoading(true);
        const _company = await API.getCompany(therapist.companyId);
        const companyRequiredFields = {
            companyName: "Firmanavn",
            address: "Firmaadresse",
            post: "Postnummer",
            town: "By",
            email: "Kontormail",
            phone: "Kontortelefon",
            CVR: "CVR",
            regNumber: "Bankregistrering",
            accountNumber: "Kontonummer"
        };
        const invalidCompanyFields = getInvalidFields(_company, companyRequiredFields);
        if (invalidCompanyFields !== "") {
            alert(`Du mangler at udfylde (Firmaindstillinger: ${invalidCompanyFields})`);
            setOpenLoading(false);
            return;
        }
        setCompany(_company);

        const _client = await API.getClient(props.booking.clientId);
        const clientRequiredFields = {
            nameFirst: "Fornavn",
            nameLast: "Efternavn",
            address: "Adresse",
            post: "Postnummer",
            town: "By",
            email: "Email",
            CPR: "CPR"
        };
        const invalidClientFields = getInvalidFields(_client, clientRequiredFields);
        if (invalidClientFields !== "") {
            alert(`Du mangler at udfylde (Klientdata: ${invalidClientFields})`);
            setOpenLoading(false);
            return;
        }
        setClient(_client);

        setTreatment(await API.getTreatment(props.booking.treatmentId));
        setClient(await API.getClient(props.booking.clientId));
        setStamJournal(await API.getCustomFieldsFromClientIsNotJournal(props.booking.clientId));
        setJournal(await API.getJournalFromBooking(props.booking.id));
        const _cvr = await API.getCvrFromNumber(_company.CVR);
        setCvr(_cvr || {});
        calcInvoiceNumber(_cvr);
        setOpen(true);
        const bookings = await API.getBookingsFromClient(props.booking.clientId);
        const map = [];
        bookings.forEach(item => {
            if (item.from >= Number(props.booking.to)) map.push(item);
        });
        if (map.length === 1) setUpComing(map);
        if (map.length > 1) setUpComing([map[0], map[1]]);
        setOpenLoading(false);
    };

    const calcInvoiceNumber = async _cvr => {
        if (!_cvr) return;

        let cvrCount = _cvr.count;

        // reset counter in new year
        const lastCvrYear = new Date(_cvr.updatedAt).getFullYear().toString().substr(-2);
        if (lastCvrYear !== curYear) {
            cvrCount = 0;
        }

        setInvoiceNumber(cvrCount);
    };

    const getInvalidFields = (data, requiredFields) => {
        const invalidFields = [];

        for (const key of Object.keys(requiredFields)) {
            if (data[key] === null || (data[key] + "").trim() === "") {
                invalidFields.push(requiredFields[key]);
            }
        }
        // console.log('invalid field', data, invalidFields);
        return invalidFields.join(", ");
    };

    const handleClose = async () => {
        setOpen(false);
    };

    const handleSave = async () => {
        let cvrCount = cvr.count;
        if (Object.keys(cvr).length === 0) {
            await API.addCvrNumber(company.CVR);
            setCvr({ count: 0 });
            cvrCount = 0;
        }

        setInvoiceNumber(cvrCount);
        const data = JSON.stringify({
            therapist: therapist,
            company: company,
            client: client,
            treatment: treatment,
            booking: props.booking,
            journal: journal,
            upComing: upComing,
            settings: {
                type: props.type,
                discount: props.discount,
                moms: props.moms,
                treatmentText: props.treatmentText,
                aktuelBehandling: props.aktuelBehandling,
                followUpText: props.followUpText
            },
            stamJournal: stamJournal,
            number: invoiceNumber + 1 + curYear
        });
        const addInvoiceRes = await API.addInvoice(invoiceNumber + 1, props.booking.id, data);
        if (addInvoiceRes.status === "failed") {
            setOpenLoading(false);
            if (addInvoiceRes.message.split("||")?.length) {
                setDineroErrorMessages(addInvoiceRes.message.split("||"));
            } else setDineroErrorMessages([addInvoiceRes.message]);
            props.close();
            return;
        }

        await API.setCvrCounter(company.CVR, invoiceNumber + 1);

        history.push("/Faktura", addInvoiceRes);
    };

    return (
        <div>
            <Button
                onClick={event => {
                    handleClickOpen();
                }}
                color="primary">
                Videre
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                fullWidth={true}
                maxWidth={"lg"}>
                <DialogContent>
                    <PDFViewer style={{ width: "100%", minHeight: "400px" }}>
                        <Document
                            title={
                                "Faktura Nummer #" +
                                getInvoiceNumber({
                                    stamJournal,
                                    journal,
                                    therapist,
                                    booking: props.booking,
                                    treatment,
                                    company,
                                    client,
                                    upComing,
                                    number: invoiceNumber + 1 + curYear
                                })
                            }>
                            <MyDocument
                                settings={{
                                    type: props.type,
                                    discount: props.discount,
                                    moms: props.moms,
                                    treatmentText: props.treatmentText,
                                    aktuelBehandling: props.aktuelBehandling,
                                    followUpText: props.followUpText
                                }}
                                stamJournal={stamJournal}
                                journal={journal}
                                therapist={update(therapist, { logo: { $set: therapist.logo || "" } })}
                                booking={props.booking}
                                treatment={treatment}
                                company={company}
                                client={client}
                                upComing={upComing}
                                number={invoiceNumber + 1 + curYear}
                            />
                        </Document>
                    </PDFViewer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Annuller
                    </Button>
                    <Button onClick={handleSave} color="primary">
                        Opret
                    </Button>
                </DialogActions>
            </Dialog>
            <Loading open={openLoading} />
        </div>
    );
};
